import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M7770 7190 c-8 -5 -12 -11 -10 -14 3 -2 14 2 24 10 22 15 10 19 -14
4z"/>
<path d="M8681 7186 c-8 -9 -11 -45 -9 -98 3 -81 4 -83 28 -83 24 0 25 2 28
83 3 78 -6 112 -28 112 -4 0 -13 -6 -19 -14z"/>
<path d="M7783 7168 c-13 -6 -23 -15 -23 -20 0 -13 13 -9 40 12 27 21 18 25
-17 8z"/>
<path d="M7546 7079 c-15 -12 -25 -24 -22 -26 3 -3 19 6 36 21 37 31 25 35
-14 5z"/>
<path d="M7505 7020 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M8013 7023 c-21 -7 -15 -38 19 -108 25 -50 37 -65 54 -65 35 0 34 22
-3 98 -36 71 -47 83 -70 75z"/>
<path d="M9322 6950 c-23 -38 -42 -76 -42 -84 0 -16 24 -28 43 -21 18 8 90
144 83 161 -13 33 -43 13 -84 -56z"/>
<path d="M1510 7000 c-524 -72 -965 -483 -1069 -997 -24 -114 -28 -309 -10
-409 27 -150 104 -327 194 -444 50 -65 150 -160 209 -198 23 -15 46 -32 53
-38 6 -6 54 -30 105 -52 280 -123 562 -130 914 -24 54 17 132 33 172 36 67 6
76 9 100 39 15 17 43 50 62 72 20 22 56 65 80 95 25 30 47 57 51 60 15 12 110
153 130 192 12 23 36 64 54 89 40 57 64 100 44 82 -7 -7 -21 -13 -30 -13 -24
0 -62 -53 -48 -67 8 -8 7 -13 0 -17 -6 -4 -11 -2 -11 3 0 18 -18 12 -24 -6 -3
-10 -4 -6 -2 10 3 24 0 27 -25 27 -26 0 -27 -1 -25 -50 2 -33 -2 -54 -11 -61
-17 -14 -17 2 0 20 10 11 9 13 -5 8 -10 -4 -18 -3 -18 2 0 4 -17 8 -37 9 -23
0 -31 -2 -21 -6 15 -6 15 -9 -3 -32 -12 -14 -18 -19 -14 -11 8 13 -5 12 -62
-10 -23 -9 -31 -33 -13 -44 5 -3 6 -13 3 -22 -5 -13 -2 -15 20 -9 29 7 34 1
15 -18 -16 -15 -51 -29 -43 -17 3 5 2 17 -1 26 -5 13 -8 14 -15 3 -7 -10 -9
-10 -9 0 0 19 -49 14 -76 -7 l-25 -20 28 -4 c18 -3 11 -5 -19 -6 -35 -1 -50 3
-58 17 -8 12 -13 13 -16 5 -10 -24 -26 -14 -20 12 9 34 -7 31 -40 -8 -59 -69
-74 -87 -74 -92 0 -2 -20 -24 -43 -47 -24 -24 -55 -59 -69 -79 -21 -28 -42
-41 -93 -58 -37 -13 -69 -20 -72 -18 -2 3 68 96 156 206 89 110 161 203 161
205 0 3 -33 -13 -73 -34 -141 -76 -263 -105 -418 -97 -88 4 -131 11 -191 32
-343 119 -513 455 -418 829 28 109 84 261 95 257 6 -2 9 -7 8 -12 -2 -4 4 -6
13 -2 8 3 13 7 10 10 -2 2 7 16 20 30 13 14 24 37 24 50 0 27 11 39 55 65 25
15 30 23 28 53 -2 25 2 35 12 35 8 0 15 8 16 18 0 10 3 12 6 5 2 -7 9 -13 14
-13 5 0 8 6 7 13 -2 6 5 11 15 10 15 -1 17 4 12 24 -3 13 -2 22 3 19 5 -3 19
7 32 21 14 17 25 23 28 15 5 -16 58 11 72 38 15 28 77 56 129 59 24 2 59 11
78 22 18 10 40 19 47 19 8 0 16 5 18 11 2 5 35 12 74 14 48 2 82 10 106 25 25
14 44 19 63 14 31 -8 180 17 163 27 -21 13 58 22 82 9 12 -6 24 -10 26 -7 4 4
-20 17 -98 51 -18 8 -49 18 -68 21 -19 4 -54 13 -78 21 -53 17 -275 26 -362
14z m-438 -492 c-7 -7 -12 -8 -12 -2 0 14 12 26 19 19 2 -3 -1 -11 -7 -17z
m26 -29 c-7 -5 -23 -9 -35 -9 -24 0 -56 -51 -47 -75 3 -7 1 -16 -5 -20 -6 -3
-11 1 -11 10 0 9 -5 13 -10 10 -6 -4 3 16 20 43 25 41 34 48 54 45 18 -4 26 0
32 19 7 20 8 21 12 4 2 -10 -2 -22 -10 -27z m1395 -1124 c-3 -9 -8 -14 -10
-11 -3 3 -2 9 2 15 9 16 15 13 8 -4z m-21 -13 c3 -11 -2 -23 -13 -30 -28 -18
-34 -14 -15 7 10 11 15 25 11 30 -3 6 -2 11 3 11 5 0 12 -8 14 -18z m-177 -82
c-3 -5 -11 -10 -16 -10 -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z
m-109 -95 c-11 -8 -22 -12 -25 -9 -6 6 19 24 34 24 6 -1 1 -7 -9 -15z m-216
-25 c0 -5 -6 -10 -12 -11 -7 0 -4 -4 7 -9 19 -8 19 -9 -2 -9 -22 -1 -31 18
-16 32 10 10 23 8 23 -3z m-23 -46 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1
17 -2 13 -5z"/>
<path d="M7510 6990 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7454 6968 c-10 -12 -13 -18 -6 -14 6 4 12 2 12 -3 0 -13 -3 -13 -24
-5 -14 5 -14 9 -4 23 7 9 -2 3 -20 -13 -18 -17 -32 -34 -32 -40 0 -6 5 -5 12
2 21 21 31 13 14 -13 -22 -33 -13 -32 28 6 19 16 42 37 52 45 18 14 18 14 0 7
-15 -5 -18 -3 -13 10 9 23 4 21 -19 -5z"/>
<path d="M2048 6893 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7300 6835 c-13 -14 -18 -25 -11 -25 7 0 9 -5 6 -10 -4 -6 -10 -8
-15 -5 -4 3 -10 -2 -14 -10 -13 -34 40 -5 74 40 11 16 11 17 0 8 -21 -19 -32
-15 -20 7 14 27 8 25 -20 -5z"/>
<path d="M7220 6721 c-14 -15 -34 -44 -44 -62 l-19 -34 31 35 c50 56 53 60 46
60 -3 0 -1 7 6 15 23 28 5 15 -20 -14z"/>
<path d="M4553 6645 c-90 -28 -166 -102 -178 -171 -9 -53 -44 -275 -90 -569
-42 -270 -64 -403 -130 -805 -37 -226 -56 -200 150 -200 l174 0 7 50 c4 28 10
50 13 50 4 0 25 -16 47 -36 114 -106 331 -130 522 -58 152 57 289 185 369 346
108 215 113 496 12 664 -40 67 -128 150 -185 175 -184 82 -407 60 -558 -56
-42 -32 -46 -33 -46 -14 0 11 23 158 50 326 28 168 50 307 50 309 0 10 -169 1
-207 -11z m442 -836 c58 -15 125 -82 149 -149 14 -39 17 -70 14 -130 -8 -138
-86 -258 -206 -317 -49 -24 -69 -28 -137 -27 -85 0 -116 11 -174 60 -56 47
-75 97 -76 199 0 82 3 97 34 163 46 98 129 175 221 203 38 11 126 10 175 -2z"/>
<path d="M9819 6487 c-71 -44 -92 -64 -86 -81 10 -24 32 -20 100 20 67 39 78
50 70 71 -7 19 -42 15 -84 -10z"/>
<path d="M1069 6423 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M9083 6348 c-25 -51 -183 -365 -350 -698 l-303 -605 32 -27 c18 -16
36 -28 40 -28 8 0 466 913 622 1239 l79 165 -29 23 c-16 12 -32 23 -36 23 -4
0 -29 -42 -55 -92z"/>
<path d="M6118 6376 c-15 -18 -19 -19 -28 -6 -11 18 -13 1 -2 -18 6 -9 14 -6
32 13 13 14 22 27 19 29 -2 2 -12 -6 -21 -18z"/>
<path d="M5831 6354 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6705 6121 c-167 -41 -317 -138 -421 -273 -155 -201 -198 -475 -107
-683 90 -208 325 -325 591 -295 165 18 306 81 425 191 157 143 237 327 237
541 0 230 -105 398 -302 487 -35 16 -87 34 -116 40 -77 16 -226 12 -307 -8z
m216 -313 c61 -18 115 -70 139 -136 18 -47 21 -71 17 -139 -6 -100 -36 -171
-103 -243 -67 -71 -139 -105 -229 -104 -163 1 -258 98 -257 263 0 243 219 424
433 359z"/>
<path d="M3043 6110 c-45 -10 -80 -35 -97 -68 -7 -15 -25 -103 -40 -197 -15
-93 -38 -240 -53 -325 -43 -262 -23 -394 80 -506 56 -62 155 -115 250 -134 69
-14 283 -15 353 -1 111 22 262 96 317 155 73 79 89 100 116 153 43 86 56 140
106 436 67 400 78 478 67 489 -6 6 -64 8 -139 6 -196 -6 -218 -25 -248 -218
-9 -63 -25 -167 -36 -230 -10 -63 -23 -148 -29 -188 -24 -172 -118 -276 -262
-289 -104 -10 -188 33 -217 110 -14 36 -14 131 -1 194 21 101 99 607 94 615
-6 10 -218 9 -261 -2z"/>
<path d="M5850 6111 c-48 -10 -84 -35 -103 -74 -9 -17 -26 -95 -37 -172 -12
-77 -30 -194 -40 -260 -60 -373 -110 -690 -110 -697 0 -4 81 -8 180 -8 l180 0
0 26 c0 14 38 262 85 550 47 289 88 552 92 584 l6 60 -109 -1 c-60 -1 -125 -4
-144 -8z"/>
<path d="M9121 6017 c-20 -117 -38 -106 171 -109 l182 -3 -31 -35 c-52 -61
-131 -176 -192 -283 -80 -141 -181 -334 -181 -346 0 -7 33 -11 90 -11 l89 0
85 168 c93 184 192 339 286 449 56 66 62 78 71 135 5 35 9 71 9 81 0 16 -20
17 -284 17 l-284 0 -11 -63z"/>
<path d="M9913 5793 c-7 -2 -13 -16 -13 -29 0 -24 2 -24 89 -24 69 0 90 3 95
15 11 29 -22 45 -92 44 -37 0 -73 -3 -79 -6z"/>
<path d="M8383 5675 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
<path d="M8060 5636 c-6 -9 -10 -21 -7 -28 4 -9 6 -7 6 4 1 9 7 18 14 21 6 2
9 7 6 11 -3 4 -12 0 -19 -8z"/>
<path d="M2685 5629 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"/>
<path d="M8208 5623 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8328 5623 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8160 5590 c0 -19 3 -21 12 -12 9 9 9 15 0 24 -9 9 -12 7 -12 -12z"/>
<path d="M8561 5594 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2656 5578 c-9 -12 -16 -27 -16 -32 0 -6 8 1 17 14 9 14 22 28 27 32
8 5 7 8 -1 8 -6 0 -19 -10 -27 -22z"/>
<path d="M7681 5549 c-19 -16 -30 -29 -25 -29 12 0 68 49 63 54 -2 3 -20 -8
-38 -25z"/>
<path d="M7810 5550 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M8195 5540 c-17 -6 -14 -9 17 -15 21 -4 46 -4 55 0 17 7 16 8 -2 15
-25 11 -45 11 -70 0z"/>
<path d="M7770 5510 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z"/>
<path d="M8449 5503 c0 -11 -3 -13 -6 -5 -7 17 -23 5 -23 -19 0 -11 4 -18 9
-15 5 3 11 -1 15 -9 3 -8 1 -15 -5 -15 -6 0 -7 -5 -3 -11 3 -6 10 -7 14 -2 11
11 17 93 8 93 -5 0 -8 -8 -9 -17z"/>
<path d="M7620 5483 c-12 -15 -25 -27 -28 -25 -4 2 -8 -2 -11 -9 -2 -7 1 -9 8
-5 6 4 11 0 11 -9 0 -10 -5 -13 -12 -9 -6 4 -8 3 -4 -4 3 -6 2 -13 -4 -17 -16
-10 -12 -45 5 -45 10 0 15 10 15 28 0 16 9 37 20 47 11 10 17 22 14 27 -3 5 0
16 7 24 6 8 9 17 7 20 -3 3 -16 -8 -28 -23z"/>
<path d="M7660 5465 c-10 -12 -10 -15 4 -15 9 0 16 7 16 15 0 8 -2 15 -4 15
-2 0 -9 -7 -16 -15z"/>
<path d="M7795 5460 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M7865 5463 c-44 -11 -31 -18 26 -15 32 2 57 8 53 13 -5 9 -44 10 -79
2z"/>
<path d="M8358 5452 c-10 -2 -18 -9 -18 -16 0 -8 -3 -28 -7 -46 -4 -24 -3 -31
5 -26 7 4 13 19 13 34 1 24 3 23 9 -8 l7 -35 2 37 c0 21 -4 38 -11 41 -8 3 -6
6 5 6 13 1 17 -8 19 -36 1 -37 1 -37 5 -6 5 40 -6 60 -29 55z"/>
<path d="M8021 5434 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2142 5400 c-7 -11 -8 -20 -3 -20 9 0 24 30 18 36 -1 2 -8 -6 -15
-16z"/>
<path d="M7713 5414 c-7 -3 -9 -12 -6 -20 3 -8 -1 -14 -11 -14 -9 0 -16 -4
-16 -10 0 -5 18 -10 41 -10 28 0 39 4 36 13 -2 6 2 20 11 30 14 16 13 17 -14
16 -16 0 -34 -3 -41 -5z"/>
<path d="M7794 5413 c11 -11 46 -14 46 -3 0 6 -12 10 -27 10 -14 0 -23 -3 -19
-7z"/>
<path d="M8012 5380 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M7640 5380 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M9695 5134 c-20 -20 -13 -29 66 -83 34 -23 68 -40 75 -37 28 11 14
44 -33 79 -76 55 -89 60 -108 41z"/>
<path d="M10156 4963 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M10127 4943 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M9950 4895 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M10040 4829 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M10010 4790 c0 -5 -6 -8 -12 -6 -7 1 -10 1 -5 -1 12 -8 8 -23 -7 -23
-17 0 -31 -18 -22 -27 7 -7 44 25 57 49 6 12 6 18 -1 18 -5 0 -10 -4 -10 -10z"/>
<path d="M9805 4743 c-26 -22 -26 -25 -7 -19 14 5 30 2 40 -6 15 -12 16 -11 3
4 -7 10 -11 25 -7 33 7 19 6 19 -29 -12z"/>
<path d="M9857 4695 c-10 -15 -13 -26 -7 -30 6 -3 15 6 20 21 14 35 9 38 -13
9z"/>
<path d="M9934 4698 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"/>
<path d="M9885 4669 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"/>
<path d="M9676 4635 c-13 -14 -26 -25 -30 -25 -4 0 -24 -11 -44 -25 -20 -14
-31 -25 -24 -25 20 0 14 -24 -10 -39 -24 -15 -79 -21 -71 -8 8 13 -16 7 -48
-12 -20 -12 -26 -21 -17 -24 10 -4 10 -6 -1 -6 -11 -1 -11 -5 2 -19 12 -13 13
-19 5 -19 -7 0 -21 -4 -30 -8 -19 -8 -25 9 -8 20 6 3 10 11 10 16 0 13 -49 3
-93 -19 -27 -14 -29 -17 -12 -20 10 -3 21 1 23 7 5 14 32 15 32 1 0 -5 -7 -10
-15 -10 -8 0 -15 -4 -15 -8 0 -5 -12 -13 -27 -19 l-28 -11 24 -8 24 -7 -24
-19 -24 -19 39 6 c43 7 163 52 185 69 7 5 20 11 28 12 23 4 125 55 119 61 -2
2 -13 0 -24 -6 -11 -6 -22 -8 -25 -4 -4 3 -23 8 -44 10 -20 2 -39 6 -42 8 -9
9 64 5 79 -4 8 -6 18 -7 23 -4 5 3 3 9 -4 14 -14 8 -20 79 -6 79 16 0 77 46
77 58 0 6 6 12 14 12 8 0 18 5 21 10 13 20 -17 9 -39 -15z m-162 -181 c3 -8
10 -12 16 -9 6 4 8 11 5 16 -10 15 12 10 25 -6 10 -12 10 -15 -1 -16 -40 -3
-74 -9 -86 -13 -8 -3 -11 -2 -8 3 3 5 0 13 -7 17 -8 5 -6 10 8 15 30 12 41 10
48 -7z m-70 -52 c2 -4 -10 -14 -27 -21 -18 -7 -42 -18 -54 -24 -13 -5 -26 -7
-30 -4 -3 4 1 7 9 7 9 0 21 7 28 15 7 8 21 15 31 15 11 0 19 5 19 10 0 12 17
13 24 2z"/>
<path d="M9834 4618 c0 -16 1 -16 21 0 11 9 21 18 23 18 2 1 -7 1 -20 1 -15
-1 -24 -8 -24 -19z"/>
<path d="M7990 4600 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M9650 4575 c-14 -16 -10 -18 14 -9 9 3 16 10 16 15 0 14 -16 11 -30
-6z"/>
<path d="M9755 4557 c-49 -29 -76 -50 -71 -54 2 -3 28 11 58 31 49 33 59 50
13 23z"/>
<path d="M9527 4543 c-34 -18 -30 -27 7 -17 14 3 26 12 26 20 0 8 -1 14 -2 13
-2 -1 -16 -8 -31 -16z"/>
<path d="M9685 4549 c-11 -17 -2 -18 19 -3 17 12 17 14 4 14 -9 0 -20 -5 -23
-11z"/>
<path d="M8110 4520 c0 -6 8 -14 18 -17 9 -4 22 -13 27 -20 8 -11 17 -12 35
-4 14 5 18 10 10 10 -8 1 -32 10 -53 21 -20 11 -37 15 -37 10z"/>
<path d="M6531 4480 c-53 -13 -114 -61 -138 -110 -43 -83 -26 -181 44 -252 27
-28 36 -47 40 -82 3 -26 10 -49 15 -52 5 -3 50 -6 100 -6 101 1 108 4 108 65
0 30 8 46 40 80 47 52 60 83 60 148 0 56 -20 112 -53 147 -49 53 -144 80 -216
62z m125 -49 c54 -25 80 -54 99 -112 21 -63 7 -111 -52 -180 -28 -33 -43 -60
-43 -79 0 -40 -21 -52 -81 -48 l-52 3 -13 46 c-8 26 -25 57 -39 70 -64 60 -82
148 -44 225 15 33 32 49 72 68 60 31 97 32 153 7z"/>
<path d="M2006 4438 c-24 -34 -24 -489 0 -512 24 -24 52 -28 184 -24 170 4
160 -13 160 282 0 193 -3 235 -16 254 -14 21 -22 22 -164 22 -142 0 -150 -1
-164 -22z m304 -252 c0 -204 -2 -235 -16 -240 -20 -8 -228 -8 -248 0 -14 5
-16 36 -16 240 l0 234 140 0 140 0 0 -234z"/>
<path d="M2143 4005 c-7 -19 13 -36 37 -32 8 1 15 11 15 22 0 26 -42 34 -52
10z"/>
<path d="M2640 4175 c0 -183 4 -285 10 -285 6 0 10 102 10 285 0 183 -4 285
-10 285 -6 0 -10 -102 -10 -285z"/>
<path d="M3690 4181 c0 -159 4 -282 9 -285 5 -4 11 -2 13 4 8 25 -3 560 -12
560 -6 0 -10 -106 -10 -279z"/>
<path d="M4800 4174 c0 -187 3 -283 10 -279 6 4 10 110 10 286 0 179 -4 279
-10 279 -6 0 -10 -102 -10 -286z"/>
<path d="M6025 4449 c-8 -22 -1 -555 8 -549 9 6 12 548 3 557 -3 3 -8 0 -11
-8z"/>
<path d="M7107 4453 c-11 -11 -8 -551 3 -558 7 -4 10 92 10 279 0 157 -1 286
-3 286 -2 0 -7 -3 -10 -7z"/>
<path d="M2974 4431 c-53 -32 -74 -68 -74 -125 0 -99 96 -249 209 -325 70 -48
178 -85 220 -76 33 7 111 85 111 111 0 21 -83 99 -122 115 -25 10 -32 8 -63
-15 l-35 -27 -30 21 c-37 26 -100 100 -100 116 0 7 10 29 21 49 l21 36 -26 37
c-31 44 -84 102 -94 102 -4 0 -21 -9 -38 -19z m79 -79 c30 -42 31 -43 14 -71
-23 -40 -21 -65 9 -111 26 -39 123 -120 144 -120 7 0 23 9 37 20 35 27 48 25
95 -11 47 -38 47 -64 0 -96 -38 -25 -61 -23 -152 10 -70 25 -193 146 -233 226
-34 69 -36 137 -6 175 29 36 54 30 92 -22z"/>
<path d="M8300 4441 c0 -10 54 -31 79 -31 9 0 -4 9 -28 20 -49 23 -51 23 -51
11z"/>
<path d="M4036 4421 c-76 -11 -78 -16 -74 -228 4 -221 -2 -212 135 -213 50 0
94 -4 97 -8 8 -14 -8 -30 -34 -33 -14 -2 -25 -11 -25 -19 0 -12 20 -15 110
-18 61 -1 116 2 124 7 19 12 5 31 -25 31 -17 0 -24 5 -24 20 0 19 7 20 93 20
139 0 137 -3 137 208 0 92 -3 177 -6 189 -12 45 -56 53 -266 52 -106 -1 -215
-5 -242 -8z m455 -41 c18 -10 19 -23 19 -175 0 -131 -3 -166 -15 -178 -12 -13
-53 -15 -229 -16 -118 -1 -226 3 -240 9 l-26 10 0 169 c0 151 2 171 18 180 23
14 447 14 473 1z m-214 -424 c-5 -15 -47 -16 -47 0 0 7 6 14 13 17 18 6 38 -4
34 -17z"/>
<path d="M5160 4421 c-49 -13 -59 -57 -59 -244 0 -94 5 -179 11 -192 21 -47
43 -50 317 -48 l256 2 28 31 27 30 0 170 c0 197 -8 230 -60 249 -36 12 -476
14 -520 2z m520 -51 c19 -19 20 -31 18 -197 l-3 -177 -25 -13 c-18 -9 -89 -13
-250 -13 -161 0 -232 4 -250 13 l-25 13 -3 178 c-2 156 0 181 14 197 16 18 36
19 261 19 231 0 244 -1 263 -20z"/>
<path d="M5256 4284 c-22 -21 -20 -50 5 -75 25 -25 46 -22 72 13 19 25 19 28
3 52 -19 30 -56 34 -80 10z"/>
<path d="M5450 4280 c0 -19 7 -20 95 -20 88 0 95 1 95 20 0 19 -7 20 -95 20
-88 0 -95 -1 -95 -20z"/>
<path d="M5450 4200 c0 -19 6 -20 96 -20 86 0 95 2 92 18 -3 14 -17 17 -96 20
-87 3 -92 2 -92 -18z"/>
<path d="M5264 4162 c-28 -4 -61 -41 -66 -72 -3 -25 -3 -25 86 -28 49 -2 95
-1 102 2 18 7 0 67 -23 81 -22 13 -71 21 -99 17z"/>
<path d="M5452 4113 c3 -16 15 -18 93 -18 78 0 90 2 93 18 3 15 -7 17 -93 17
-86 0 -96 -2 -93 -17z"/>
<path d="M8285 4416 c11 -7 34 -16 50 -20 30 -6 30 -6 -5 14 -41 22 -76 28
-45 6z"/>
<path d="M9195 4408 c-102 -23 -110 -26 -87 -27 12 0 22 -5 22 -11 0 -5 16
-10 35 -10 27 0 35 4 35 19 0 12 11 22 33 29 40 12 16 13 -38 0z"/>
<path d="M8400 4400 c-20 -6 -21 -8 -5 -8 11 0 31 4 45 8 20 6 21 8 5 8 -11 0
-31 -4 -45 -8z"/>
<path d="M8513 4383 c9 -2 17 -11 17 -18 0 -7 8 -16 18 -18 11 -3 7 -5 -10 -6
-14 0 -34 2 -44 6 -16 6 -16 7 2 15 16 7 15 8 -5 4 -13 -3 -32 -1 -42 5 -10 5
-20 5 -23 0 -6 -9 14 -18 98 -45 60 -19 87 -20 85 -3 -4 31 3 37 39 38 23 1 6
6 -48 15 -83 13 -122 16 -87 7z"/>
<path d="M8995 4369 c-38 -5 -39 -5 -10 -10 17 -3 -22 -3 -85 -1 -64 3 -147 1
-185 -3 l-70 -9 45 -7 c69 -11 198 -13 271 -5 66 8 116 -4 104 -24 -3 -4 1
-11 7 -13 7 -3 2 -6 -11 -6 -13 -1 -22 -3 -19 -6 3 -4 30 -3 59 1 42 6 49 9
34 16 -15 6 -10 7 16 4 19 -2 51 -1 70 4 31 7 32 8 7 9 -16 1 -28 6 -28 11 0
6 -15 10 -34 10 -19 0 -38 5 -41 10 -3 6 -24 10 -45 10 -21 0 -40 3 -42 8 -1
4 -21 4 -43 1z m-97 -26 c-27 -2 -69 -2 -95 0 -27 2 -5 3 47 3 52 0 74 -1 48
-3z"/>
<path d="M8685 4320 c-3 -5 4 -10 17 -11 23 -1 23 -1 -2 -8 -24 -7 -24 -7 9
-14 18 -4 48 -7 65 -6 30 1 30 1 6 9 -23 7 -22 8 10 10 31 1 27 3 -25 15 -75
17 -73 17 -80 5z"/>
<path d="M8966 4319 c-11 -7 -44 -9 -80 -6 l-61 5 53 -10 c37 -8 63 -8 88 0
20 6 36 6 40 1 3 -5 13 -9 22 -8 14 0 13 2 -3 8 l-20 8 20 5 c14 4 11 6 -10 7
-16 0 -38 -4 -49 -10z"/>
<path d="M8868 4278 c35 -6 70 -6 100 0 42 9 37 10 -53 10 -95 0 -97 -1 -47
-10z"/>
<path d="M7382 4204 c-42 -29 -18 -104 34 -104 34 0 57 25 57 60 0 53 -46 76
-91 44z"/>
<path d="M7590 4213 c-41 -15 -51 -62 -20 -93 39 -39 100 -14 100 42 0 42 -38
66 -80 51z"/>
<path d="M7772 4204 c-27 -19 -29 -64 -4 -87 38 -35 95 -9 95 43 0 51 -48 75
-91 44z"/>
<path d="M800 4180 c0 -7 143 -10 410 -10 267 0 410 3 410 10 0 7 -143 10
-410 10 -267 0 -410 -3 -410 -10z"/>
<path d="M6524 3945 c-10 -26 16 -45 60 -45 43 0 66 13 66 38 0 10 -10 12 -44
7 -28 -5 -46 -3 -50 4 -10 16 -26 14 -32 -4z"/>
<path d="M1997 3764 c-4 -4 -7 -27 -7 -51 0 -42 1 -43 33 -43 18 0 38 5 45 12
14 14 16 47 4 65 -10 15 -64 28 -75 17z m47 -20 c19 -7 21 -35 4 -52 -23 -23
-38 -13 -38 23 0 35 5 40 34 29z"/>
<path d="M2185 3760 c-3 -5 1 -10 9 -10 12 0 16 -10 16 -40 0 -22 5 -40 10
-40 6 0 10 18 10 40 0 30 4 40 16 40 8 0 12 5 9 10 -3 6 -19 10 -35 10 -16 0
-32 -4 -35 -10z"/>
<path d="M2304 3762 c-10 -7 -46 -92 -38 -92 2 0 13 6 24 12 16 10 24 10 40 0
23 -14 24 -10 7 40 -16 45 -19 49 -33 40z m16 -47 c0 -8 -4 -15 -10 -15 -5 0
-10 7 -10 15 0 8 5 15 10 15 6 0 10 -7 10 -15z"/>
<path d="M3041 3718 c1 -29 3 -45 6 -35 5 21 29 23 37 2 10 -28 21 -15 23 29
2 38 -1 45 -20 50 -44 12 -47 8 -46 -46z m49 17 c0 -8 -6 -15 -14 -15 -17 0
-28 14 -19 24 12 12 33 6 33 -9z"/>
<path d="M3125 3760 c-3 -5 1 -10 9 -10 12 0 16 -10 16 -39 0 -54 16 -60 23
-9 3 24 11 44 16 46 6 2 11 8 11 13 0 12 -67 12 -75 -1z"/>
<path d="M3227 3763 c-11 -10 -8 -93 3 -93 6 0 10 23 10 50 0 51 -1 55 -13 43z"/>
<path d="M3268 3719 c-1 -27 0 -49 5 -49 4 0 7 12 7 28 l0 27 20 -25 20 -25
21 25 c20 24 21 25 16 3 -3 -13 -1 -26 4 -29 5 -3 9 18 9 47 0 44 -2 50 -15
39 -8 -6 -17 -20 -20 -31 -9 -26 -23 -24 -31 5 -11 47 -32 38 -36 -15z"/>
<path d="M3404 3756 c-3 -8 -4 -31 -2 -52 3 -33 6 -37 31 -39 16 0 31 3 33 7
3 4 -6 8 -20 8 -32 0 -35 27 -3 33 l22 4 -22 8 c-31 10 -29 25 3 25 14 0 23 4
19 10 -9 15 -55 12 -61 -4z"/>
<path d="M3926 3757 c-12 -9 -17 -23 -14 -47 3 -32 6 -35 41 -38 22 -2 37 1
37 8 0 6 -10 8 -24 4 -30 -7 -50 21 -34 49 7 14 16 17 34 13 26 -7 33 8 8 18
-22 9 -28 8 -48 -7z"/>
<path d="M4043 3757 c-15 -19 -34 -80 -27 -86 4 -3 9 0 11 7 6 14 39 16 48 2
17 -27 22 -5 8 35 -17 51 -26 60 -40 42z m21 -48 c-3 -5 -10 -7 -15 -3 -5 3
-7 10 -3 15 3 5 10 7 15 3 5 -3 7 -10 3 -15z"/>
<path d="M4127 3763 c-4 -3 -7 -26 -7 -50 0 -43 0 -43 35 -43 21 0 35 5 36 13
3 33 -4 73 -15 79 -14 10 -41 10 -49 1z m43 -23 c0 -5 -7 -10 -15 -10 -8 0
-15 5 -15 10 0 6 7 10 15 10 8 0 15 -4 15 -10z m3 -45 c1 -5 -6 -11 -15 -13
-11 -2 -18 3 -18 13 0 17 30 18 33 0z"/>
<path d="M4307 3763 c-9 -9 -9 -91 1 -96 4 -2 21 0 37 4 l30 7 -27 1 c-34 1
-38 28 -5 34 l22 4 -22 8 c-31 10 -29 25 3 25 14 0 23 4 19 10 -7 11 -48 14
-58 3z"/>
<path d="M4436 3761 c-3 -5 1 -11 9 -14 9 -4 13 -18 11 -42 -1 -20 1 -38 6
-41 4 -3 8 13 8 35 0 28 5 43 18 50 9 6 15 11 12 12 -35 7 -60 8 -64 0z"/>
<path d="M4583 3750 c-6 -14 -13 -32 -16 -40 -3 -10 -9 -5 -17 18 -11 29 -30
44 -30 23 0 -19 31 -81 41 -81 13 0 41 67 36 88 -3 13 -6 11 -14 -8z"/>
<path d="M4997 3763 c-4 -3 -7 -26 -7 -50 l0 -43 38 1 c30 2 32 3 10 6 -32 5
-38 33 -8 33 11 0 20 5 20 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 9 10
20 10 11 0 20 5 20 10 0 11 -43 14 -53 3z"/>
<path d="M5080 3768 c0 -4 5 -19 12 -32 9 -22 8 -29 -7 -46 -16 -17 -16 -20
-2 -20 9 0 20 7 25 17 9 14 11 14 21 -6 7 -12 16 -19 21 -16 6 4 3 17 -7 31
-12 19 -13 28 -4 37 6 6 11 18 11 26 0 12 -3 11 -18 -2 -17 -15 -19 -15 -35 0
-9 10 -17 14 -17 11z"/>
<path d="M5203 3753 c-3 -10 -12 -33 -19 -50 -12 -30 -4 -47 11 -23 3 6 15 10
26 10 10 0 19 -4 19 -10 0 -5 7 -10 14 -10 12 0 11 9 -6 50 -22 52 -34 62 -45
33z m27 -32 c0 -6 -4 -13 -10 -16 -5 -3 -10 1 -10 9 0 9 5 16 10 16 6 0 10 -4
10 -9z"/>
<path d="M5287 3763 c-11 -10 -8 -93 3 -93 6 0 10 10 10 23 l0 22 19 -24 19
-24 15 29 16 29 1 -27 c0 -16 5 -28 10 -28 13 0 13 87 -1 95 -5 4 -15 -7 -22
-24 -14 -39 -22 -39 -42 -1 -17 32 -18 33 -28 23z"/>
<path d="M5470 3750 c-23 -23 -24 -33 -10 -61 12 -21 64 -27 75 -9 4 7 -2 9
-17 5 -16 -4 -29 -1 -38 10 -19 23 0 51 34 48 29 -2 35 11 10 21 -25 9 -33 7
-54 -14z"/>
<path d="M5587 3749 c-22 -33 -32 -79 -18 -79 6 0 11 5 11 10 0 6 9 10 19 10
11 0 23 -4 26 -10 3 -5 10 -10 16 -10 9 0 -17 77 -32 94 -4 4 -14 -2 -22 -15z
m23 -34 c0 -8 -4 -15 -10 -15 -5 0 -10 7 -10 15 0 8 5 15 10 15 6 0 10 -7 10
-15z"/>
<path d="M5670 3718 c1 -50 2 -52 16 -33 14 19 16 19 25 3 16 -29 25 -21 27
26 1 38 -2 45 -21 50 -44 12 -47 8 -47 -46z m50 17 c0 -8 -6 -15 -14 -15 -17
0 -28 14 -19 24 12 12 33 6 33 -9z"/>
<path d="M5767 3763 c-4 -3 -7 -26 -7 -50 l0 -44 43 3 c41 3 42 4 45 41 3 32
0 38 -23 47 -31 12 -49 13 -58 3z m61 -44 c2 -18 -3 -29 -14 -33 -19 -7 -34 8
-34 35 0 39 43 37 48 -2z"/>
<path d="M6137 3763 c-4 -3 -7 -26 -7 -50 l0 -43 38 1 c21 1 28 3 17 6 -33 8
-42 23 -17 29 27 8 29 24 2 24 -11 0 -20 5 -20 10 0 6 12 10 26 10 14 0 23 4
19 10 -7 11 -48 14 -58 3z"/>
<path d="M6227 3763 c-4 -7 -7 -31 -5 -53 2 -39 3 -40 37 -39 32 1 33 2 11 8
-21 6 -26 14 -30 51 -3 27 -8 40 -13 33z"/>
<path d="M6317 3763 c-4 -3 -7 -26 -7 -50 l0 -43 38 1 c30 2 32 3 10 6 -34 5
-37 30 -5 36 l22 4 -22 8 c-32 10 -29 25 5 25 21 0 24 2 12 10 -17 11 -44 13
-53 3z"/>
<path d="M6416 3757 c-12 -9 -17 -23 -14 -47 3 -32 6 -35 41 -38 22 -2 37 1
37 8 0 6 -10 8 -24 4 -30 -7 -50 21 -34 49 7 14 16 17 34 13 26 -7 33 8 8 18
-22 9 -28 8 -48 -7z"/>
<path d="M6500 3761 c0 -5 7 -11 15 -15 9 -3 15 -19 15 -41 0 -19 5 -35 11
-35 6 0 9 15 7 37 -2 22 2 38 10 41 25 8 11 22 -23 22 -19 0 -35 -4 -35 -9z"/>
<path d="M6597 3763 c-11 -10 -8 -93 3 -93 6 0 10 7 10 15 0 8 6 15 14 15 8 0
16 -7 20 -15 10 -28 21 -15 21 25 0 25 -6 44 -15 50 -18 11 -44 13 -53 3z m46
-28 c1 -5 -6 -11 -15 -13 -11 -2 -18 3 -18 13 0 17 30 18 33 0z"/>
<path d="M6690 3721 c0 -28 5 -51 10 -51 6 0 10 20 10 44 0 25 -4 48 -10 51
-6 4 -10 -13 -10 -44z"/>
<path d="M6752 3754 c-24 -17 -29 -53 -10 -72 15 -15 64 -16 73 -2 4 7 -2 9
-17 5 -16 -4 -29 -1 -37 9 -19 23 -9 51 19 53 43 2 45 3 30 13 -21 13 -32 12
-58 -6z"/>
<path d="M6880 3761 c0 -5 6 -11 14 -14 8 -3 17 -23 19 -44 l4 -38 1 43 c2 35
5 42 23 42 11 0 17 5 14 10 -8 12 -75 13 -75 1z"/>
<path d="M7408 3738 c-4 -40 1 -68 12 -68 4 0 6 9 3 20 -3 11 0 20 6 20 6 0
11 -7 11 -15 0 -21 27 -19 39 3 9 15 10 15 11 -5 0 -13 5 -23 10 -23 6 0 10
21 10 46 0 49 -16 57 -35 16 -12 -27 -22 -28 -30 -3 -3 11 -12 24 -19 30 -11
9 -15 5 -18 -21z"/>
<path d="M7550 3750 c-23 -23 -24 -33 -10 -61 16 -29 78 -27 89 4 10 26 4 47
-17 65 -22 17 -39 15 -62 -8z m59 -19 c13 -24 -9 -57 -33 -48 -23 9 -31 34
-16 52 17 20 37 19 49 -4z"/>
<path d="M7666 3758 c-3 -7 -7 -30 -10 -50 -4 -29 -1 -38 10 -38 8 0 13 4 9 9
-3 5 0 13 6 17 6 4 16 -1 21 -10 15 -27 23 -18 26 28 2 38 -1 44 -20 50 -33 8
-38 8 -42 -6z m44 -23 c0 -8 -6 -15 -14 -15 -17 0 -28 14 -19 24 12 12 33 6
33 -9z"/>
<path d="M7757 3763 c-4 -3 -7 -25 -7 -49 0 -39 2 -42 30 -46 17 -3 33 -1 36
3 2 4 -6 9 -18 11 -28 4 -27 22 2 26 25 4 16 22 -11 22 -11 0 -17 5 -14 10 3
6 15 10 26 10 11 0 17 5 14 10 -7 11 -48 14 -58 3z"/>
<path d="M2106 3719 c-9 -23 -14 -44 -10 -48 4 -3 9 0 11 7 3 6 15 12 28 12
13 0 25 -6 28 -12 2 -7 7 -10 11 -7 10 10 -24 89 -39 89 -7 0 -20 -19 -29 -41z
m38 -10 c-3 -5 -10 -7 -15 -3 -5 3 -7 10 -3 15 3 5 10 7 15 3 5 -3 7 -10 3
-15z"/>
<path d="M2897 3718 c-17 -43 -15 -60 5 -40 15 15 48 16 48 2 0 -5 4 -10 9
-10 6 0 3 20 -6 45 -8 25 -21 45 -27 45 -7 0 -20 -19 -29 -42z m36 7 c4 -8 2
-17 -3 -20 -6 -4 -10 3 -10 14 0 25 6 27 13 6z"/>
<path d="M2990 3715 c0 -25 5 -45 10 -45 6 0 10 20 10 45 0 25 -4 45 -10 45
-5 0 -10 -20 -10 -45z"/>
<path d="M4220 3715 c0 -44 0 -45 33 -44 23 1 26 3 10 6 -19 4 -23 11 -23 44
0 21 -4 39 -10 39 -5 0 -10 -20 -10 -45z"/>
<path d="M6840 3715 c0 -25 5 -45 10 -45 6 0 10 20 10 45 0 25 -4 45 -10 45
-5 0 -10 -20 -10 -45z"/>
<path d="M6970 3752 c0 -4 5 -13 11 -19 6 -6 15 -26 19 -45 6 -28 8 -30 14
-13 4 11 14 35 22 53 14 33 3 45 -16 15 -10 -17 -10 -17 -20 0 -11 17 -30 23
-30 9z"/>
<path d="M1327 3314 c-3 -3 7 -39 22 -80 21 -61 30 -74 45 -72 23 4 72 136 57
151 -9 9 -35 -39 -48 -91 -7 -30 -19 -15 -34 45 -10 38 -29 59 -42 47z"/>
<path d="M2153 3313 c-7 -3 -13 -10 -13 -16 0 -7 -7 -20 -14 -30 -13 -17 -15
-16 -32 12 -10 17 -24 31 -31 31 -17 0 -17 -1 12 -51 14 -24 25 -56 25 -71 0
-18 5 -28 15 -28 10 0 15 10 15 33 0 17 11 51 24 74 24 42 24 55 -1 46z"/>
<path d="M3055 3308 c-2 -7 -6 -31 -7 -53 l-3 -40 -30 47 c-17 28 -38 48 -47
48 -16 0 -18 -10 -18 -75 0 -59 3 -75 14 -75 11 0 16 15 18 52 l3 53 34 -53
c47 -74 61 -69 61 22 0 68 -13 107 -25 74z"/>
<path d="M3265 3313 c-49 -12 -72 -73 -45 -123 15 -29 61 -40 98 -24 26 11 32
19 32 44 0 27 -3 30 -30 30 -16 0 -30 -4 -30 -10 0 -5 7 -10 15 -10 22 0 18
-28 -5 -35 -33 -10 -60 12 -60 49 0 44 20 60 65 52 41 -8 48 9 9 24 -14 6 -26
9 -27 9 -1 -1 -11 -4 -22 -6z"/>
<path d="M3723 3312 c-5 -4 -17 -20 -25 -36 l-16 -30 -16 32 c-9 18 -24 32
-32 32 -13 0 -11 -9 10 -46 14 -26 26 -59 26 -75 0 -19 5 -29 15 -29 10 0 15
10 15 32 0 17 11 50 25 74 23 40 23 62 -2 46z"/>
<path d="M3904 3310 c-28 -11 -54 -48 -54 -76 0 -12 9 -33 21 -48 26 -33 86
-37 114 -6 53 59 -10 158 -81 130z m52 -28 c22 -14 26 -52 10 -77 -19 -29 -47
-32 -70 -9 -43 42 11 119 60 86z"/>
<path d="M4235 3308 c-2 -7 -6 -35 -7 -62 -3 -56 -25 -79 -52 -57 -11 9 -16
30 -16 67 0 41 -4 54 -15 54 -11 0 -15 -13 -15 -53 0 -67 20 -97 64 -97 48 0
66 25 66 93 0 52 -14 85 -25 55z"/>
<path d="M4810 3310 c-4 -3 -7 -38 -6 -77 l1 -73 53 0 c59 0 71 17 15 22 -30
2 -38 7 -38 23 0 16 9 21 40 26 41 5 34 15 -15 21 -41 5 -31 32 13 36 20 2 37
7 37 12 0 9 -87 18 -100 10z"/>
<path d="M5050 3312 c-6 -2 -10 -36 -10 -78 l0 -74 55 0 c30 0 55 5 55 10 0 6
-18 10 -41 10 -36 0 -40 2 -37 23 2 17 11 23 36 25 43 4 41 22 -3 22 -28 0
-35 4 -35 20 0 17 7 20 40 20 22 0 40 4 40 9 0 9 -80 19 -100 13z"/>
<path d="M6379 3286 c-12 -20 -23 -36 -25 -36 -2 0 -10 14 -19 30 -9 17 -22
30 -30 30 -20 0 -19 -4 10 -50 14 -22 25 -53 25 -70 0 -20 5 -30 15 -30 10 0
15 10 15 32 0 17 11 50 25 74 15 26 21 45 15 49 -5 3 -19 -10 -31 -29z"/>
<path d="M6776 3313 c-3 -3 -6 -39 -6 -80 0 -53 4 -73 13 -73 9 0 14 21 15 74
3 68 -5 96 -22 79z"/>
<path d="M8226 3311 c-4 -6 4 -31 18 -56 14 -24 26 -56 26 -70 0 -17 5 -25 13
-22 6 2 11 11 9 20 -1 9 9 39 23 66 29 58 30 61 12 61 -8 0 -19 -11 -25 -25
-11 -23 -32 -35 -32 -17 0 4 -9 18 -19 31 -12 16 -20 20 -25 12z"/>
<path d="M8630 3296 c-5 -15 -13 -38 -16 -52 -8 -31 -19 -21 -31 26 -14 53
-38 50 -52 -5 -13 -53 -26 -52 -36 5 -4 26 -12 40 -22 40 -11 0 -14 -6 -9 -22
3 -13 11 -47 17 -75 17 -72 42 -73 59 -2 14 56 25 54 38 -6 6 -30 13 -40 27
-40 15 0 22 14 36 70 11 42 14 74 9 79 -6 6 -13 -1 -20 -18z"/>
<path d="M1100 3235 l0 -75 55 0 c62 0 75 17 18 22 -30 2 -38 7 -38 23 0 11 6
21 13 21 6 1 21 2 32 3 35 2 22 21 -15 21 -28 0 -35 4 -35 20 0 17 7 20 40 20
22 0 40 5 40 10 0 6 -25 10 -55 10 l-55 0 0 -75z"/>
<path d="M1588 3303 c-2 -5 -3 -37 -3 -73 l0 -65 53 -3 c59 -3 73 15 15 20
-30 2 -38 7 -38 23 0 11 6 21 13 21 6 1 21 2 32 3 35 2 22 21 -15 21 -28 0
-35 4 -35 20 0 17 7 20 40 20 22 0 40 5 40 10 0 11 -97 14 -102 3z"/>
<path d="M1820 3235 c0 -60 3 -75 15 -75 9 0 15 9 15 24 0 38 18 41 38 7 9
-17 23 -31 30 -31 15 0 15 6 1 32 -8 15 -8 26 1 43 7 13 10 35 6 49 -6 24 -11
26 -56 26 l-50 0 0 -75z m75 30 c0 -13 -8 -21 -22 -23 -19 -3 -23 1 -23 23 0
22 4 26 23 23 14 -2 22 -10 22 -23z"/>
<path d="M2285 3300 c3 -5 15 -10 26 -10 17 0 19 -7 19 -65 0 -51 3 -65 15
-65 12 0 15 14 15 65 0 63 1 65 25 65 14 0 25 5 25 10 0 6 -29 10 -66 10 -41
0 -63 -4 -59 -10z"/>
<path d="M2530 3235 c0 -60 3 -75 15 -75 10 0 15 10 15 30 0 17 5 31 10 31 51
6 55 4 58 -29 2 -20 8 -32 15 -29 17 5 16 139 0 144 -9 3 -13 -6 -13 -26 0
-29 -3 -31 -35 -31 -32 0 -35 2 -35 30 0 20 -5 30 -15 30 -12 0 -15 -15 -15
-75z"/>
<path d="M2790 3235 c0 -60 3 -75 15 -75 12 0 15 15 15 75 0 60 -3 75 -15 75
-12 0 -15 -15 -15 -75z"/>
<path d="M4550 3235 c0 -43 4 -75 10 -75 6 0 10 20 10 45 0 25 4 45 9 45 4 0
21 -20 37 -45 42 -66 54 -60 54 30 0 43 -4 75 -10 75 -5 0 -10 -12 -11 -27 0
-16 -4 -36 -7 -46 -6 -15 -12 -10 -36 28 -43 67 -56 60 -56 -30z"/>
<path d="M5272 3238 l3 -73 46 -3 c51 -3 75 14 85 64 4 21 0 37 -16 57 -18 23
-29 27 -71 27 l-50 0 3 -72z m92 36 c22 -21 20 -50 -5 -75 -34 -34 -54 -21
-57 39 -3 50 -2 52 22 52 13 0 32 -7 40 -16z"/>
<path d="M5827 3303 c-3 -5 -17 -39 -31 -76 -20 -55 -22 -67 -10 -67 8 0 17 7
20 15 4 9 19 15 39 15 20 0 35 -6 39 -15 4 -12 36 -23 36 -12 0 1 -13 34 -29
72 -27 64 -51 89 -64 68z m33 -64 c0 -10 -7 -19 -15 -19 -16 0 -19 9 -9 34 8
20 24 11 24 -15z"/>
<path d="M6040 3235 c0 -60 3 -75 15 -75 11 0 15 12 15 52 l0 53 33 -52 c18
-30 39 -53 50 -53 15 0 17 10 17 75 0 59 -3 75 -14 75 -11 0 -16 -14 -18 -47
l-3 -48 -34 48 c-49 68 -61 63 -61 -28z"/>
<path d="M6530 3300 c0 -5 9 -10 20 -10 18 0 20 -7 20 -65 0 -51 3 -65 15 -65
12 0 15 14 15 65 0 63 1 65 25 65 14 0 25 5 25 10 0 6 -27 10 -60 10 -33 0
-60 -4 -60 -10z"/>
<path d="M6930 3235 c0 -60 3 -75 15 -75 11 0 15 12 16 48 l0 47 20 -43 c22
-50 37 -51 58 -4 16 35 33 43 30 15 -3 -39 2 -64 12 -61 10 3 14 61 10 131 -2
33 -32 17 -52 -28 -11 -25 -23 -45 -27 -45 -4 0 -15 20 -25 45 -13 31 -25 45
-38 45 -17 0 -19 -8 -19 -75z"/>
<path d="M7230 3235 l0 -75 55 0 c30 0 55 5 55 10 0 6 -17 10 -38 10 -21 0
-41 3 -44 6 -9 9 3 44 14 38 5 -3 21 -3 35 1 31 8 20 22 -22 27 -45 5 -39 32
8 36 55 5 45 22 -13 22 l-50 0 0 -75z"/>
<path d="M7751 3288 c-5 -13 -18 -47 -30 -75 -17 -45 -18 -53 -6 -53 9 0 18 7
21 15 8 20 64 19 79 -1 6 -9 17 -15 22 -13 16 6 -41 143 -61 147 -9 2 -20 -6
-25 -20z m39 -49 c0 -10 -7 -19 -15 -19 -15 0 -21 31 -9 43 11 10 24 -3 24
-24z"/>
<path d="M7970 3235 c0 -60 3 -75 15 -75 11 0 15 12 15 52 l0 53 32 -53 c20
-31 40 -52 50 -52 16 0 18 10 18 75 0 60 -3 75 -15 75 -11 0 -15 -12 -15 -45
0 -25 -3 -45 -7 -45 -5 0 -21 20 -36 45 -43 68 -57 60 -57 -30z"/>
<path d="M8781 3235 c-1 -62 1 -75 14 -75 10 0 15 10 15 29 0 21 6 30 23 35
41 11 47 7 47 -29 0 -24 5 -35 15 -35 12 0 15 15 15 75 0 60 -3 75 -15 75 -10
0 -15 -10 -15 -30 0 -28 -3 -30 -35 -30 -32 0 -35 2 -35 30 0 19 -5 30 -14 30
-10 0 -14 -19 -15 -75z"/>
<path d="M9040 3235 l0 -75 55 0 c62 0 75 17 18 22 -53 4 -58 34 -9 44 46 8
46 24 0 24 -28 0 -35 3 -32 18 2 12 14 18 41 20 57 5 44 22 -18 22 l-55 0 0
-75z"/>
<path d="M9280 3235 c0 -43 4 -75 10 -75 6 0 10 11 10 24 0 44 37 40 53 -6 4
-10 13 -18 22 -18 19 0 19 5 0 34 -14 21 -14 24 0 36 18 15 20 51 3 68 -7 7
-31 12 -55 12 l-43 0 0 -75z m75 30 c0 -31 -49 -28 -53 3 -3 20 0 23 25 20 20
-2 28 -8 28 -23z"/>
<path d="M9520 3235 l0 -75 55 0 c30 0 55 5 55 10 0 6 -18 10 -40 10 -36 0
-40 3 -40 25 0 22 4 25 36 25 21 0 33 4 29 10 -3 6 -19 10 -36 10 -22 0 -29 5
-29 20 0 16 7 20 35 20 19 0 35 5 35 10 0 6 -22 10 -50 10 l-50 0 0 -75z"/>
<path d="M5500 3158 c1 -31 1 -32 15 -13 17 21 15 37 -3 43 -8 2 -12 -8 -12
-30z"/>
<path d="M7428 3165 c-3 -14 -1 -28 3 -31 10 -6 29 37 22 49 -9 15 -21 6 -25
-18z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
